import type { Product, Category } from '@/types/product';

export const categories = [
  {
    "key": "engagement",
    "label": "טבעות אירוסין",
    "eyebrow": "ENGAGEMENT",
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg"
  },
  {
    "key": "wedding",
    "label": "טבעות נישואין",
    "eyebrow": "WEDDING BANDS",
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852"
  },
  {
    "key": "rings",
    "label": "טבעות",
    "eyebrow": "DIAMOND RINGS",
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
  },
  {
    "key": "earrings",
    "label": "עגילים",
    "eyebrow": "EARRINGS",
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
  },
  {
    "key": "necklaces",
    "label": "שרשראות",
    "eyebrow": "NECKLACES",
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp"
  },
  {
    "key": "bracelets",
    "label": "צמידים",
    "eyebrow": "BRACELETS",
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp"
  },
  {
    "key": "gemstones",
    "label": "אבני חן",
    "eyebrow": "GEMSTONES",
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787"
  },
  {
    "key": "pearls",
    "label": "פנינים",
    "eyebrow": "PEARLS",
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp"
  },
  {
    "key": "silver",
    "label": "כסף ומואסנייט",
    "eyebrow": "SILVER & MOISSANITE",
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg"
  },
  {
    "key": "ready",
    "label": "מוכנים למשלוח",
    "eyebrow": "READY TO SHIP",
    "image": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000"
  }
] satisfies Category[];

export const initialProducts = [
  {
    "id": 1,
    "slug": "jewelry-001",
    "name": "טבעת יהלום יחיד – סוליטר ארבע שיניים",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "סוליטר",
    "price": 2975,
    "oldPrice": 3500,
    "cost": 0,
    "sku": "VE-1100",
    "shape": "עגול",
    "carat": "0.50–3.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 0,
    "lowStockThreshold": 3,
    "featured": true,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת יהלום יחיד – סוליטר ארבע שיניים | MIELLEY",
    "seoDescription": "טבעת יהלום יחיד – סוליטר ארבע שיניים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת יהלום יחיד – סוליטר ארבע שיניים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 2,
    "slug": "jewelry-002",
    "name": "טבעת רדיאן BEZEL",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "בזל",
    "price": 4675,
    "oldPrice": 5500,
    "cost": 0,
    "sku": "VE-1101",
    "shape": "רדיאן",
    "carat": "1.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת רדיאן BEZEL | MIELLEY",
    "seoDescription": "טבעת רדיאן BEZEL מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת רדיאן BEZEL מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 3,
    "slug": "jewelry-003",
    "name": "טבעת אירוסין אנג'ל – עיצוב אישי",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "עיצוב אישי",
    "price": 4633,
    "oldPrice": 5450,
    "cost": 0,
    "sku": "VE-1102",
    "shape": "אובל",
    "carat": "1.20–3.20 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת אירוסין אנג'ל – עיצוב אישי | MIELLEY",
    "seoDescription": "טבעת אירוסין אנג'ל – עיצוב אישי מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת אירוסין אנג'ל – עיצוב אישי מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 4,
    "slug": "jewelry-004",
    "name": "טבעת אירוסין אובל מרקיזה",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "אבני צד",
    "price": 4165,
    "oldPrice": 4900,
    "cost": 0,
    "sku": "VE-1103",
    "shape": "אובל",
    "carat": "1.50–2.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת אירוסין אובל מרקיזה | MIELLEY",
    "seoDescription": "טבעת אירוסין אובל מרקיזה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת אירוסין אובל מרקיזה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 5,
    "slug": "jewelry-005",
    "name": "טבעת אירוסין אנסטסיה",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "היילו",
    "price": 6205,
    "oldPrice": 7300,
    "cost": 0,
    "sku": "VE-1104",
    "shape": "עגול",
    "carat": "1.50–2.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת אירוסין אנסטסיה | MIELLEY",
    "seoDescription": "טבעת אירוסין אנסטסיה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת אירוסין אנסטסיה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 6,
    "slug": "jewelry-006",
    "name": "טבעת שלושה יהלומים גדולה",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "שלוש אבנים",
    "price": 4548,
    "oldPrice": 5350,
    "cost": 0,
    "sku": "VE-1105",
    "shape": "עגול",
    "carat": "1.30 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת שלושה יהלומים גדולה | MIELLEY",
    "seoDescription": "טבעת שלושה יהלומים גדולה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת שלושה יהלומים גדולה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 7,
    "slug": "jewelry-007",
    "name": "טבעת שלישיית אמרלדים פרימיום",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "שלוש אבנים",
    "price": 7225,
    "oldPrice": 8500,
    "cost": 0,
    "sku": "VE-1106",
    "shape": "אמרלד",
    "carat": "2.10 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת שלישיית אמרלדים פרימיום | MIELLEY",
    "seoDescription": "טבעת שלישיית אמרלדים פרימיום מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת שלישיית אמרלדים פרימיום מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 8,
    "slug": "jewelry-008",
    "name": "טבעת אירוסין לוטוס",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "פרח",
    "price": 5865,
    "oldPrice": 6900,
    "cost": 0,
    "sku": "VE-1107",
    "shape": "עגול",
    "carat": "1.00–2.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת אירוסין לוטוס | MIELLEY",
    "seoDescription": "טבעת אירוסין לוטוס מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת אירוסין לוטוס מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 9,
    "slug": "jewelry-009",
    "name": "Classics – טבעת אירוסין סוליטר",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "סוליטר",
    "price": 3450,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1108",
    "shape": "עגול",
    "carat": "0.50–3.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "Classics – טבעת אירוסין סוליטר | MIELLEY",
    "seoDescription": "Classics – טבעת אירוסין סוליטר מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Classics – טבעת אירוסין סוליטר מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 10,
    "slug": "jewelry-010",
    "name": "Major – טבעת אירוסין אבני צד",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "אבני צד",
    "price": 5450,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1109",
    "shape": "עגול",
    "carat": "1.00–3.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": true,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "Major – טבעת אירוסין אבני צד | MIELLEY",
    "seoDescription": "Major – טבעת אירוסין אבני צד מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Major – טבעת אירוסין אבני צד מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 11,
    "slug": "jewelry-011",
    "name": "Mai – טבעת אירוסין מודרנית",
    "category": "engagement",
    "categoryLabel": "טבעות אירוסין",
    "subcategory": "עיצוב אישי",
    "price": 6250,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1110",
    "shape": "אובל",
    "carat": "1.00–2.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/Print_Screen-41.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-45.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2023/11/Print_Screen-44.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "Mai – טבעת אירוסין מודרנית | MIELLEY",
    "seoDescription": "Mai – טבעת אירוסין מודרנית מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Mai – טבעת אירוסין מודרנית מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 12,
    "slug": "jewelry-012",
    "name": "Ready Oval – טבעת אירוסין",
    "category": "ready",
    "categoryLabel": "מוכנים למשלוח",
    "subcategory": "אובל",
    "price": 5490,
    "oldPrice": 6290,
    "cost": 0,
    "sku": "VE-1111",
    "shape": "אובל",
    "carat": "0.80 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": true,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Ready Oval – טבעת אירוסין | MIELLEY",
    "seoDescription": "Ready Oval – טבעת אירוסין מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Ready Oval – טבעת אירוסין מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 13,
    "slug": "jewelry-013",
    "name": "Ready Radiant – טבעת אירוסין",
    "category": "ready",
    "categoryLabel": "מוכנים למשלוח",
    "subcategory": "רדיאן",
    "price": 6190,
    "oldPrice": 6990,
    "cost": 0,
    "sku": "VE-1112",
    "shape": "רדיאן",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": true,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Ready Radiant – טבעת אירוסין | MIELLEY",
    "seoDescription": "Ready Radiant – טבעת אירוסין מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Ready Radiant – טבעת אירוסין מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 14,
    "slug": "jewelry-014",
    "name": "Ready Emerald – טבעת אירוסין",
    "category": "ready",
    "categoryLabel": "מוכנים למשלוח",
    "subcategory": "אמרלד",
    "price": 6590,
    "oldPrice": 7490,
    "cost": 0,
    "sku": "VE-1113",
    "shape": "אמרלד",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": true,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Ready Emerald – טבעת אירוסין | MIELLEY",
    "seoDescription": "Ready Emerald – טבעת אירוסין מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Ready Emerald – טבעת אירוסין מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 15,
    "slug": "jewelry-015",
    "name": "Ready Pear – טבעת אירוסין",
    "category": "ready",
    "categoryLabel": "מוכנים למשלוח",
    "subcategory": "טיפה",
    "price": 5790,
    "oldPrice": 6490,
    "cost": 0,
    "sku": "VE-1114",
    "shape": "טיפה",
    "carat": "0.90 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
      "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/files/The_Ring_That_Starts_Everything.png?v=1773779995&width=2000",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": true,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Ready Pear – טבעת אירוסין | MIELLEY",
    "seoDescription": "Ready Pear – טבעת אירוסין מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Ready Pear – טבעת אירוסין מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 16,
    "slug": "jewelry-016",
    "name": "טבעת דיאנה מרקיזה",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "מרקיזה",
    "price": 3740,
    "oldPrice": 4400,
    "cost": 0,
    "sku": "VE-1115",
    "shape": "מרקיזה",
    "carat": "0.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת דיאנה מרקיזה | MIELLEY",
    "seoDescription": "טבעת דיאנה מרקיזה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת דיאנה מרקיזה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 17,
    "slug": "jewelry-017",
    "name": "טבעת ליבי",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "לב",
    "price": 1828,
    "oldPrice": 2150,
    "cost": 0,
    "sku": "VE-1116",
    "shape": "לב",
    "carat": "0.25 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת ליבי | MIELLEY",
    "seoDescription": "טבעת ליבי מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת ליבי מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 18,
    "slug": "jewelry-018",
    "name": "טבעת ספירל טיפות",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "אבני חן",
    "price": 6375,
    "oldPrice": 7500,
    "cost": 0,
    "sku": "VE-1117",
    "shape": "טיפה",
    "carat": "1.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת ספירל טיפות | MIELLEY",
    "seoDescription": "טבעת ספירל טיפות מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת ספירל טיפות מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 19,
    "slug": "jewelry-019",
    "name": "טבעת פריזמה",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "קולקציה",
    "price": 5290,
    "oldPrice": 6200,
    "cost": 0,
    "sku": "VE-1118",
    "shape": "פרינסס",
    "carat": "1.20 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": true,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת פריזמה | MIELLEY",
    "seoDescription": "טבעת פריזמה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת פריזמה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 20,
    "slug": "jewelry-020",
    "name": "טבעת רויאל אובל",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "רויאל",
    "price": 11475,
    "oldPrice": 13500,
    "cost": 0,
    "sku": "VE-1119",
    "shape": "אובל",
    "carat": "3.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת רויאל אובל | MIELLEY",
    "seoDescription": "טבעת רויאל אובל מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת רויאל אובל מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 21,
    "slug": "jewelry-021",
    "name": "טבעת מרקיזה טוויסט",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "טוויסט",
    "price": 5440,
    "oldPrice": 6400,
    "cost": 0,
    "sku": "VE-1120",
    "shape": "מרקיזה",
    "carat": "1.20 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת מרקיזה טוויסט | MIELLEY",
    "seoDescription": "טבעת מרקיזה טוויסט מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת מרקיזה טוויסט מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 22,
    "slug": "jewelry-022",
    "name": "טבעת WAVE",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "קולקציה",
    "price": 3358,
    "oldPrice": 3950,
    "cost": 0,
    "sku": "VE-1121",
    "shape": "עגול",
    "carat": "0.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת WAVE | MIELLEY",
    "seoDescription": "טבעת WAVE מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת WAVE מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 23,
    "slug": "jewelry-023",
    "name": "טבעת אדווה",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "קולקציה",
    "price": 5525,
    "oldPrice": 6500,
    "cost": 0,
    "sku": "VE-1122",
    "shape": "עגול",
    "carat": "1.00–2.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 0,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת אדווה | MIELLEY",
    "seoDescription": "טבעת אדווה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת אדווה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 24,
    "slug": "jewelry-024",
    "name": "Jewel – טבעת שבעה יהלומים",
    "category": "rings",
    "categoryLabel": "טבעות",
    "subcategory": "איטרניטי",
    "price": 4890,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1123",
    "shape": "עגול",
    "carat": "0.51 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/7-copy-1.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2024/03/9831b.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "Jewel – טבעת שבעה יהלומים | MIELLEY",
    "seoDescription": "Jewel – טבעת שבעה יהלומים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Jewel – טבעת שבעה יהלומים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 25,
    "slug": "jewelry-025",
    "name": "Promise – טבעת נישואין לנשים",
    "category": "wedding",
    "categoryLabel": "טבעות נישואין",
    "subcategory": "נשים",
    "price": 2190,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1124",
    "shape": "עגול",
    "carat": "0.12 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "Promise – טבעת נישואין לנשים | MIELLEY",
    "seoDescription": "Promise – טבעת נישואין לנשים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Promise – טבעת נישואין לנשים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 26,
    "slug": "jewelry-026",
    "name": "Eternal – טבעת נישואין יהלומים",
    "category": "wedding",
    "categoryLabel": "טבעות נישואין",
    "subcategory": "נשים",
    "price": 3890,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1125",
    "shape": "עגול",
    "carat": "0.35 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "Eternal – טבעת נישואין יהלומים | MIELLEY",
    "seoDescription": "Eternal – טבעת נישואין יהלומים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Eternal – טבעת נישואין יהלומים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 27,
    "slug": "jewelry-027",
    "name": "Atlas – טבעת נישואין לגברים",
    "category": "wedding",
    "categoryLabel": "טבעות נישואין",
    "subcategory": "גברים",
    "price": 2490,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1126",
    "shape": "ללא אבן",
    "carat": "—",
    "color": "—",
    "clarity": "—",
    "cut": "—",
    "stone": "ללא אבן",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "—",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "Atlas – טבעת נישואין לגברים | MIELLEY",
    "seoDescription": "Atlas – טבעת נישואין לגברים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Atlas – טבעת נישואין לגברים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 28,
    "slug": "jewelry-028",
    "name": "Noah – טבעת גברים מוברשת",
    "category": "wedding",
    "categoryLabel": "טבעות נישואין",
    "subcategory": "גברים",
    "price": 2790,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1127",
    "shape": "ללא אבן",
    "carat": "—",
    "color": "—",
    "clarity": "—",
    "cut": "—",
    "stone": "ללא אבן",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": true,
    "readyToShip": false,
    "certificateType": "—",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "Noah – טבעת גברים מוברשת | MIELLEY",
    "seoDescription": "Noah – טבעת גברים מוברשת מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Noah – טבעת גברים מוברשת מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 29,
    "slug": "jewelry-029",
    "name": "טבעת נישואין קלאסית דקה",
    "category": "wedding",
    "categoryLabel": "טבעות נישואין",
    "subcategory": "נשים",
    "price": 1890,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1128",
    "shape": "ללא אבן",
    "carat": "—",
    "color": "—",
    "clarity": "—",
    "cut": "—",
    "stone": "ללא אבן",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "—",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת נישואין קלאסית דקה | MIELLEY",
    "seoDescription": "טבעת נישואין קלאסית דקה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת נישואין קלאסית דקה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 30,
    "slug": "jewelry-030",
    "name": "טבעת נישואין רחבה מבריקה",
    "category": "wedding",
    "categoryLabel": "טבעות נישואין",
    "subcategory": "גברים",
    "price": 3290,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1129",
    "shape": "ללא אבן",
    "carat": "—",
    "color": "—",
    "clarity": "—",
    "cut": "—",
    "stone": "ללא אבן",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/wedding-menu.jpg?v=90920296740430083311784016852",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "—",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": true,
    "seoTitle": "טבעת נישואין רחבה מבריקה | MIELLEY",
    "seoDescription": "טבעת נישואין רחבה מבריקה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת נישואין רחבה מבריקה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 31,
    "slug": "jewelry-031",
    "name": "Emerald Bloom – טבעת אמרלד",
    "category": "gemstones",
    "categoryLabel": "אבני חן",
    "subcategory": "אמרלד",
    "price": 6490,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1130",
    "shape": "אמרלד",
    "carat": "1.20 CT",
    "color": "אמרלד",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "אמרלד",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Emerald Bloom – טבעת אמרלד | MIELLEY",
    "seoDescription": "Emerald Bloom – טבעת אמרלד מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Emerald Bloom – טבעת אמרלד מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 32,
    "slug": "jewelry-032",
    "name": "Sapphire Line – טבעת ספיר",
    "category": "gemstones",
    "categoryLabel": "אבני חן",
    "subcategory": "ספיר",
    "price": 5890,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1131",
    "shape": "אובל",
    "carat": "1.10 CT",
    "color": "ספיר",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "ספיר",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Sapphire Line – טבעת ספיר | MIELLEY",
    "seoDescription": "Sapphire Line – טבעת ספיר מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Sapphire Line – טבעת ספיר מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 33,
    "slug": "jewelry-033",
    "name": "Ruby Halo – טבעת רובי",
    "category": "gemstones",
    "categoryLabel": "אבני חן",
    "subcategory": "רובי",
    "price": 6250,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1132",
    "shape": "אובל",
    "carat": "1.00 CT",
    "color": "רובי",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "רובי",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Ruby Halo – טבעת רובי | MIELLEY",
    "seoDescription": "Ruby Halo – טבעת רובי מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Ruby Halo – טבעת רובי מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 34,
    "slug": "jewelry-034",
    "name": "טבעת מורגנייט ורודה",
    "category": "gemstones",
    "categoryLabel": "אבני חן",
    "subcategory": "מורגנייט",
    "price": 5790,
    "oldPrice": 6800,
    "cost": 0,
    "sku": "VE-1133",
    "shape": "קושן",
    "carat": "1.50 CT",
    "color": "מורגנייט",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "מורגנייט",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
      "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787"
    ],
    "image": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
    "hoverImage": "https://www.joolme.co.il/cdn/shop/t/37/assets/menu-img-1.jpg?v=10930790582282657961784016787",
    "status": "active",
    "stockQty": 0,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "טבעת מורגנייט ורודה | MIELLEY",
    "seoDescription": "טבעת מורגנייט ורודה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת מורגנייט ורודה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 35,
    "slug": "jewelry-035",
    "name": "עגיל יהלומים עלים",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "תלויים",
    "price": 7565,
    "oldPrice": 8900,
    "cost": 0,
    "sku": "VE-1134",
    "shape": "מרקיזה",
    "carat": "2.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגיל יהלומים עלים | MIELLEY",
    "seoDescription": "עגיל יהלומים עלים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגיל יהלומים עלים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 36,
    "slug": "jewelry-036",
    "name": "עגיל מיקה מלבני",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "צמודים",
    "price": 4165,
    "oldPrice": 4900,
    "cost": 0,
    "sku": "VE-1135",
    "shape": "אמרלד",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגיל מיקה מלבני | MIELLEY",
    "seoDescription": "עגיל מיקה מלבני מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגיל מיקה מלבני מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 37,
    "slug": "jewelry-037",
    "name": "עגיל סופיה",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "צמודים",
    "price": 3528,
    "oldPrice": 4150,
    "cost": 0,
    "sku": "VE-1136",
    "shape": "עגול",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": true,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגיל סופיה | MIELLEY",
    "seoDescription": "עגיל סופיה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגיל סופיה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 38,
    "slug": "jewelry-038",
    "name": "עגיל רויאל סימפוני",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "תלויים",
    "price": 6970,
    "oldPrice": 8200,
    "cost": 0,
    "sku": "VE-1137",
    "shape": "טיפה",
    "carat": "2.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגיל רויאל סימפוני | MIELLEY",
    "seoDescription": "עגיל רויאל סימפוני מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגיל רויאל סימפוני מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 39,
    "slug": "jewelry-039",
    "name": "עגילי מרקיזה פרח",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "פרח",
    "price": 3613,
    "oldPrice": 4250,
    "cost": 0,
    "sku": "VE-1138",
    "shape": "מרקיזה",
    "carat": "0.80 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגילי מרקיזה פרח | MIELLEY",
    "seoDescription": "עגילי מרקיזה פרח מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגילי מרקיזה פרח מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 40,
    "slug": "jewelry-040",
    "name": "עגילי סופיה תלויים",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "תלויים",
    "price": 9775,
    "oldPrice": 11500,
    "cost": 0,
    "sku": "VE-1139",
    "shape": "עגול",
    "carat": "3.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגילי סופיה תלויים | MIELLEY",
    "seoDescription": "עגילי סופיה תלויים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגילי סופיה תלויים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 41,
    "slug": "jewelry-041",
    "name": "עגילי תלתן טיפה",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "תלויים",
    "price": 4760,
    "oldPrice": 5600,
    "cost": 0,
    "sku": "VE-1140",
    "shape": "טיפה",
    "carat": "1.20 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגילי תלתן טיפה | MIELLEY",
    "seoDescription": "עגילי תלתן טיפה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגילי תלתן טיפה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 42,
    "slug": "jewelry-042",
    "name": "עגיל הליקס שתי שורות DIVINE",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "פירסינג",
    "price": 2253,
    "oldPrice": 2650,
    "cost": 0,
    "sku": "VE-1141",
    "shape": "עגול",
    "carat": "0.25 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגיל הליקס שתי שורות DIVINE | MIELLEY",
    "seoDescription": "עגיל הליקס שתי שורות DIVINE מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגיל הליקס שתי שורות DIVINE מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 43,
    "slug": "jewelry-043",
    "name": "Classic Hoops – חישוקי יהלומים",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "חישוקים",
    "price": 3990,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1142",
    "shape": "עגול",
    "carat": "0.55 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Classic Hoops – חישוקי יהלומים | MIELLEY",
    "seoDescription": "Classic Hoops – חישוקי יהלומים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Classic Hoops – חישוקי יהלומים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 44,
    "slug": "jewelry-044",
    "name": "Signature Studs – עגילי סוליטר",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "צמודים",
    "price": 3490,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1143",
    "shape": "עגול",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Signature Studs – עגילי סוליטר | MIELLEY",
    "seoDescription": "Signature Studs – עגילי סוליטר מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Signature Studs – עגילי סוליטר מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 45,
    "slug": "jewelry-045",
    "name": "Pear Motion – עגילים תלויים",
    "category": "earrings",
    "categoryLabel": "עגילים",
    "subcategory": "תלויים",
    "price": 5790,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1144",
    "shape": "טיפה",
    "carat": "1.20 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1.jpg.webp",
    "status": "active",
    "stockQty": 0,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Pear Motion – עגילים תלויים | MIELLEY",
    "seoDescription": "Pear Motion – עגילים תלויים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Pear Motion – עגילים תלויים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 46,
    "slug": "jewelry-046",
    "name": "צמיד טניס קלאסי",
    "category": "bracelets",
    "categoryLabel": "צמידים",
    "subcategory": "טניס",
    "price": 7920,
    "oldPrice": 9900,
    "cost": 0,
    "sku": "VE-1145",
    "shape": "עגול",
    "carat": "3.00–10.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": true,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "צמיד טניס קלאסי | MIELLEY",
    "seoDescription": "צמיד טניס קלאסי מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "צמיד טניס קלאסי מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 47,
    "slug": "jewelry-047",
    "name": "צמיד אמצע היד – Hand Chain",
    "category": "bracelets",
    "categoryLabel": "צמידים",
    "subcategory": "חוליות",
    "price": 3032,
    "oldPrice": 3790,
    "cost": 0,
    "sku": "VE-1146",
    "shape": "עגול",
    "carat": "0.30 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "צמיד אמצע היד – Hand Chain | MIELLEY",
    "seoDescription": "צמיד אמצע היד – Hand Chain מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "צמיד אמצע היד – Hand Chain מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 48,
    "slug": "jewelry-048",
    "name": "צמיד טניס טיפה צ׳ארם",
    "category": "bracelets",
    "categoryLabel": "צמידים",
    "subcategory": "טניס",
    "price": 5520,
    "oldPrice": 6900,
    "cost": 0,
    "sku": "VE-1147",
    "shape": "טיפה",
    "carat": "1.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "צמיד טניס טיפה צ׳ארם | MIELLEY",
    "seoDescription": "צמיד טניס טיפה צ׳ארם מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "צמיד טניס טיפה צ׳ארם מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 49,
    "slug": "jewelry-049",
    "name": "צמיד טניס מרקיזה צ׳ארם",
    "category": "bracelets",
    "categoryLabel": "צמידים",
    "subcategory": "טניס",
    "price": 5520,
    "oldPrice": 6900,
    "cost": 0,
    "sku": "VE-1148",
    "shape": "מרקיזה",
    "carat": "1.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "צמיד טניס מרקיזה צ׳ארם | MIELLEY",
    "seoDescription": "צמיד טניס מרקיזה צ׳ארם מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "צמיד טניס מרקיזה צ׳ארם מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 50,
    "slug": "jewelry-050",
    "name": "צמיד סוליטר יהלום",
    "category": "bracelets",
    "categoryLabel": "צמידים",
    "subcategory": "סוליטר",
    "price": 3040,
    "oldPrice": 3800,
    "cost": 0,
    "sku": "VE-1149",
    "shape": "עגול",
    "carat": "0.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "צמיד סוליטר יהלום | MIELLEY",
    "seoDescription": "צמיד סוליטר יהלום מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "צמיד סוליטר יהלום מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 51,
    "slug": "jewelry-051",
    "name": "Tennis Essential – צמיד יהלומים",
    "category": "bracelets",
    "categoryLabel": "צמידים",
    "subcategory": "טניס",
    "price": 8990,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1150",
    "shape": "עגול",
    "carat": "4.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Tennis Essential – צמיד יהלומים | MIELLEY",
    "seoDescription": "Tennis Essential – צמיד יהלומים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Tennis Essential – צמיד יהלומים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 52,
    "slug": "jewelry-052",
    "name": "Line Bangle – צמיד קשיח",
    "category": "bracelets",
    "categoryLabel": "צמידים",
    "subcategory": "קשיח",
    "price": 4490,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1151",
    "shape": "עגול",
    "carat": "0.45 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-1.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Line Bangle – צמיד קשיח | MIELLEY",
    "seoDescription": "Line Bangle – צמיד קשיח מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Line Bangle – צמיד קשיח מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 53,
    "slug": "jewelry-053",
    "name": "שרשרת דואט",
    "category": "necklaces",
    "categoryLabel": "שרשראות",
    "subcategory": "שרשראות יהלומים",
    "price": 3825,
    "oldPrice": 4500,
    "cost": 0,
    "sku": "VE-1152",
    "shape": "עגול",
    "carat": "0.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "שרשרת דואט | MIELLEY",
    "seoDescription": "שרשרת דואט מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "שרשרת דואט מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 54,
    "slug": "jewelry-054",
    "name": "שרשרת טיפת יהלומים 1 קראט",
    "category": "necklaces",
    "categoryLabel": "שרשראות",
    "subcategory": "תליון יהלום",
    "price": 4930,
    "oldPrice": 5800,
    "cost": 0,
    "sku": "VE-1153",
    "shape": "טיפה",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "שרשרת טיפת יהלומים 1 קראט | MIELLEY",
    "seoDescription": "שרשרת טיפת יהלומים 1 קראט מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "שרשרת טיפת יהלומים 1 קראט מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 55,
    "slug": "jewelry-055",
    "name": "שרשרת מעגל אהבה",
    "category": "necklaces",
    "categoryLabel": "שרשראות",
    "subcategory": "מעגל",
    "price": 7565,
    "oldPrice": 8900,
    "cost": 0,
    "sku": "VE-1154",
    "shape": "עגול",
    "carat": "1.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": true,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "שרשרת מעגל אהבה | MIELLEY",
    "seoDescription": "שרשרת מעגל אהבה מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "שרשרת מעגל אהבה מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 56,
    "slug": "jewelry-056",
    "name": "ILUMA Prism – שרשרת",
    "category": "necklaces",
    "categoryLabel": "שרשראות",
    "subcategory": "ILUMA",
    "price": 6630,
    "oldPrice": 7800,
    "cost": 0,
    "sku": "VE-1155",
    "shape": "פרינסס",
    "carat": "1.20 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "status": "active",
    "stockQty": 0,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "ILUMA Prism – שרשרת | MIELLEY",
    "seoDescription": "ILUMA Prism – שרשרת מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "ILUMA Prism – שרשרת מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 57,
    "slug": "jewelry-057",
    "name": "סוליטר לב – שרשרת יהלום",
    "category": "necklaces",
    "categoryLabel": "שרשראות",
    "subcategory": "סוליטר",
    "price": 3290,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1156",
    "shape": "לב",
    "carat": "0.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "סוליטר לב – שרשרת יהלום | MIELLEY",
    "seoDescription": "סוליטר לב – שרשרת יהלום מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "סוליטר לב – שרשרת יהלום מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 58,
    "slug": "jewelry-058",
    "name": "Solitaire Drop – תליון יהלום",
    "category": "necklaces",
    "categoryLabel": "שרשראות",
    "subcategory": "סוליטר",
    "price": 2990,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1157",
    "shape": "עגול",
    "carat": "0.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Solitaire Drop – תליון יהלום | MIELLEY",
    "seoDescription": "Solitaire Drop – תליון יהלום מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Solitaire Drop – תליון יהלום מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 59,
    "slug": "jewelry-059",
    "name": "Initial Diamond – שרשרת אות",
    "category": "necklaces",
    "categoryLabel": "שרשראות",
    "subcategory": "אותיות",
    "price": 1890,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1158",
    "shape": "עגול",
    "carat": "0.10 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-2.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "Initial Diamond – שרשרת אות | MIELLEY",
    "seoDescription": "Initial Diamond – שרשרת אות מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "Initial Diamond – שרשרת אות מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 60,
    "slug": "jewelry-060",
    "name": "צמיד פנינים שלוש שורות",
    "category": "pearls",
    "categoryLabel": "פנינים",
    "subcategory": "פנינים",
    "price": 6800,
    "oldPrice": 8500,
    "cost": 0,
    "sku": "VE-1159",
    "shape": "עגול",
    "carat": "0.50 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "צמיד פנינים שלוש שורות | MIELLEY",
    "seoDescription": "צמיד פנינים שלוש שורות מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "צמיד פנינים שלוש שורות מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 61,
    "slug": "jewelry-061",
    "name": "שרשרת פנינים ויהלום",
    "category": "pearls",
    "categoryLabel": "פנינים",
    "subcategory": "פנינים",
    "price": 4590,
    "oldPrice": 5400,
    "cost": 0,
    "sku": "VE-1160",
    "shape": "עגול",
    "carat": "0.25 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "שרשרת פנינים ויהלום | MIELLEY",
    "seoDescription": "שרשרת פנינים ויהלום מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "שרשרת פנינים ויהלום מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 62,
    "slug": "jewelry-062",
    "name": "עגילי פנינה צמודים",
    "category": "pearls",
    "categoryLabel": "פנינים",
    "subcategory": "פנינים",
    "price": 2290,
    "oldPrice": 0,
    "cost": 0,
    "sku": "VE-1161",
    "shape": "עגול",
    "carat": "0.10 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "יהלום מעבדה",
    "metals": [
      "זהב לבן",
      "זהב צהוב",
      "זהב ורוד"
    ],
    "purities": [
      "14K",
      "18K"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/Untitled-1-1-3.jpg.webp",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגילי פנינה צמודים | MIELLEY",
    "seoDescription": "עגילי פנינה צמודים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגילי פנינה צמודים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 63,
    "slug": "jewelry-063",
    "name": "טבעת סוליטר אובל כסף ומואסנייט",
    "category": "silver",
    "categoryLabel": "כסף ומואסנייט",
    "subcategory": "סוליטר",
    "price": 399,
    "oldPrice": 499,
    "cost": 0,
    "sku": "VE-1162",
    "shape": "אובל",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "מואסנייט",
    "metals": [
      "כסף 925"
    ],
    "purities": [
      "כסף 925"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "טבעת סוליטר אובל כסף ומואסנייט | MIELLEY",
    "seoDescription": "טבעת סוליטר אובל כסף ומואסנייט מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת סוליטר אובל כסף ומואסנייט מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 64,
    "slug": "jewelry-064",
    "name": "טבעת סוליטר טיפה כסף ומואסנייט",
    "category": "silver",
    "categoryLabel": "כסף ומואסנייט",
    "subcategory": "סוליטר",
    "price": 399,
    "oldPrice": 499,
    "cost": 0,
    "sku": "VE-1163",
    "shape": "טיפה",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "מואסנייט",
    "metals": [
      "כסף 925"
    ],
    "purities": [
      "כסף 925"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": true,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "טבעת סוליטר טיפה כסף ומואסנייט | MIELLEY",
    "seoDescription": "טבעת סוליטר טיפה כסף ומואסנייט מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת סוליטר טיפה כסף ומואסנייט מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 65,
    "slug": "jewelry-065",
    "name": "טבעת שבע אבנים כסף ומואסנייט",
    "category": "silver",
    "categoryLabel": "כסף ומואסנייט",
    "subcategory": "איטרניטי",
    "price": 479,
    "oldPrice": 599,
    "cost": 0,
    "sku": "VE-1164",
    "shape": "עגול",
    "carat": "0.70 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "מואסנייט",
    "metals": [
      "כסף 925"
    ],
    "purities": [
      "כסף 925"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "טבעת שבע אבנים כסף ומואסנייט | MIELLEY",
    "seoDescription": "טבעת שבע אבנים כסף ומואסנייט מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "טבעת שבע אבנים כסף ומואסנייט מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 66,
    "slug": "jewelry-066",
    "name": "שרשרת מואסנייט כסף",
    "category": "silver",
    "categoryLabel": "כסף ומואסנייט",
    "subcategory": "שרשראות",
    "price": 792,
    "oldPrice": 990,
    "cost": 0,
    "sku": "VE-1165",
    "shape": "עגול",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "מואסנייט",
    "metals": [
      "כסף 925"
    ],
    "purities": [
      "כסף 925"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "status": "active",
    "stockQty": 10,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "שרשרת מואסנייט כסף | MIELLEY",
    "seoDescription": "שרשרת מואסנייט כסף מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "שרשרת מואסנייט כסף מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  },
  {
    "id": 67,
    "slug": "jewelry-067",
    "name": "עגילי מואסנייט צמודים",
    "category": "silver",
    "categoryLabel": "כסף ומואסנייט",
    "subcategory": "צמודים",
    "price": 559,
    "oldPrice": 699,
    "cost": 0,
    "sku": "VE-1166",
    "shape": "עגול",
    "carat": "1.00 CT",
    "color": "D–F",
    "clarity": "VS–VVS",
    "cut": "Excellent",
    "stone": "מואסנייט",
    "metals": [
      "כסף 925"
    ],
    "purities": [
      "כסף 925"
    ],
    "gallery": [
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
      "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg"
    ],
    "image": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "hoverImage": "https://www.xlabdiamonds.co.il/wp-content/uploads/2022/08/5623-e1661694672698.jpg",
    "status": "active",
    "stockQty": 0,
    "lowStockThreshold": 3,
    "featured": false,
    "readyToShip": false,
    "certificateType": "IGI",
    "certificateNumber": "",
    "deliveryDays": "7–14 ימי עסקים",
    "engraving": false,
    "seoTitle": "עגילי מואסנייט צמודים | MIELLEY",
    "seoDescription": "עגילי מואסנייט צמודים מבית MIELLEY – יהלומי מעבדה ותכשיטים בעיצוב מוקפד.",
    "description": "עגילי מואסנייט צמודים מבית MIELLEY, בעיצוב מוקפד עם אפשרויות התאמה אישית. מפרט האבן, המתכת והמידה מוצגים בשקיפות מלאה."
  }
] satisfies Product[];
